export const WHATSAPP_CHATTING_PATIENT_MESSAGES_GET_START =
  "WHATSAPP_CHATTING_PATIENT_MESSAGES_GET_START";
export const WHATSAPP_CHATTING_PATIENT_MESSAGES_GET_SUCCESS =
  "WHATSAPP_CHATTING_PATIENT_MESSAGES_GET_SUCCESS";
export const WHATSAPP_CHATTING_PATIENT_MESSAGES_GET_ERROR =
  "WHATSAPP_CHATTING_PATIENT_MESSAGES_GET_ERROR";

export const WHATSAPP_CHATTING_PATIENT_MESSAGES_READ_START =
  "WHATSAPP_CHATTING_PATIENT_MESSAGES_READ_START";
export const WHATSAPP_CHATTING_PATIENT_MESSAGES_READ_SUCCESS =
  "WHATSAPP_CHATTING_PATIENT_MESSAGES_READ_SUCCESS";
export const WHATSAPP_CHATTING_PATIENT_MESSAGES_READ_ERROR =
  "WHATSAPP_CHATTING_PATIENT_MESSAGES_READ_ERROR";

export const WHATSAPP_CHATTING_PATIENT_SEND_IMAGE_START =
  "WHATSAPP_CHATTING_PATIENT_SEND_IMAGE_START";
export const WHATSAPP_CHATTING_PATIENT_SEND_IMAGE_SUCCESS =
  "WHATSAPP_CHATTING_PATIENT_SEND_IMAGE_SUCCESS";
export const WHATSAPP_CHATTING_PATIENT_SEND_IMAGE_ERROR =
  "WHATSAPP_CHATTING_PATIENT_SEND_IMAGE_ERROR";

export const WHATSAPP_CHATTING_PATIENT_SEND_MESSAGE_GET_START =
  "WHATSAPP_CHATTING_PATIENT_SEND_MESSAGE_GET_START";
export const WHATSAPP_CHATTING_PATIENT_SEND_MESSAGE_GET_SUCCESS =
  "WHATSAPP_CHATTING_PATIENT_SEND_MESSAGE_GET_SUCCESS";
export const WHATSAPP_CHATTING_PATIENT_SEND_MESSAGE_GET_ERROR =
  "WHATSAPP_CHATTING_PATIENT_SEND_MESSAGE_GET_ERROR";

export const WHATSAPP_CHATTING_PATIENT_MESSAGES_LOAD_MORE_START =
  "WHATSAPP_CHATTING_PATIENT_MESSAGES_LOAD_MORE_START";
export const WHATSAPP_CHATTING_PATIENT_MESSAGES_LOAD_MORE_SUCCESS =
  "WHATSAPP_CHATTING_PATIENT_MESSAGES_LOAD_MORE_SUCCESS";
export const WHATSAPP_CHATTING_PATIENT_MESSAGES_LOAD_MORE_ERROR =
  "WHATSAPP_CHATTING_PATIENT_MESSAGES_LOAD_MORE_ERROR";

export const WHATSAPP_CHATTING_RESET_PATIENT_MESSAGES = "WHATSAPP_CHATTING_RESET_PATIENT_MESSAGES";
